import { UserRepository } from '../../domain/repositories/user.repository';
import { userRepository } from '../repositories/user.respository';

export const userRepositoryInstance: UserRepository = userRepository();
